"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var InputSelect_1 = require("./InputSelect");
/**
 * This is just a stateful version of `<InputSelect>`. Check `<InputSelect>` for implementation examples.
 * @visibleName InputSelect.Stateful
 */
// Stateful Checkbox, which "checked" is kept in the state of component.


var Stateful =
/** @class */
function (_super) {
  __extends(Stateful, _super);

  function Stateful() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      value: _this.props.defaultValue || ""
    };
    return _this;
  }

  Stateful.prototype.render = function () {
    var _this = this;

    return React.createElement(InputSelect_1.InputSelect, __assign({}, this.props, {
      value: this.state.value,
      onChange: function onChange(value, name, event) {
        _this.setState({
          value: value
        });

        return _this.props.onChange && _this.props.onChange(value, name, event);
      }
    }));
  };

  return Stateful;
}(React.Component);

exports.Stateful = Stateful;